import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BaseUrl = process.env.REACT_APP_API_URL;

// === Thunks ===
export const fetchUsers = createAsyncThunk('home/fetchUsers', async () => {
  const response = await axios.get(`${BaseUrl}/CustomerSupport/wsetwertgvsdxsadf4556666`);
  return response.data;
});

export const fetchMembers = createAsyncThunk('home/fetchMembers', async () => {
  const response = await axios.get(`${BaseUrl}/DynamicInHouseAccounts/arfgdfhfghfghhfhhfhgfhfh`);
  return response.data;
});

export const fetchComplaints = createAsyncThunk('home/fetchComplaints', async () => {
  const response = await axios.get(`${BaseUrl}/ConplainController/dfshfsdfgjftghjfghjghx`);
  return response.data;
});

export const fetchAllTasks = createAsyncThunk('home/fetchAllTasks', async () => {
  const response = await axios.get(`${BaseUrl}/TaskManagement/AssignTaskDataFun`);
  return response.data;
});

export const fetchTaskFind = createAsyncThunk('home/fetchTaskFind', async () => {
  const response = await axios.get(`${BaseUrl}/TaskManagement/Taskfind`);
  return response.data;
});

// === Slice ===
const userSlice = createSlice({
  name: 'home',
  initialState: {
    // Users
    loading: false,
    data: [],
    error: null,

    // Members
    membersLoading: false,
    membersData: [],
    membersError: null,

    // Complaints
    complaintsLoading: false,
    complaintsData: [],
    complaintsError: null,

    // Tasks
    tasksLoading: false,
    tasksData: [],
    tasksError: null,

    // Sub Tasks
    ShowSubTaskLoading: false,
    ShowSubTaskData: [],
    ShowSubTaskError: null,
  },
  extraReducers: (builder) => {
    // === Users ===
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    // === Members ===
    builder
      .addCase(fetchMembers.pending, (state) => {
        state.membersLoading = true;
        state.membersError = null;
      })
      .addCase(fetchMembers.fulfilled, (state, action) => {
        state.membersLoading = false;
        state.membersData = action.payload;
      })
      .addCase(fetchMembers.rejected, (state, action) => {
        state.membersLoading = false;
        state.membersError = action.error.message;
      });

    // === Complaints ===
    builder
      .addCase(fetchComplaints.pending, (state) => {
        state.complaintsLoading = true;
        state.complaintsError = null;
      })
      .addCase(fetchComplaints.fulfilled, (state, action) => {
        state.complaintsLoading = false;
        state.complaintsData = action.payload;
      })
      .addCase(fetchComplaints.rejected, (state, action) => {
        state.complaintsLoading = false;
        state.complaintsError = action.error.message;
      });

    // === All Tasks ===
    builder
      .addCase(fetchAllTasks.pending, (state) => {
        state.tasksLoading = true;
        state.tasksError = null;
      })
      .addCase(fetchAllTasks.fulfilled, (state, action) => {
        state.tasksLoading = false;
        state.tasksData = action.payload;
      })
      .addCase(fetchAllTasks.rejected, (state, action) => {
        state.tasksLoading = false;
        state.tasksError = action.error.message;
      });

    // === Sub Tasks (TaskFind) ===
    builder
      .addCase(fetchTaskFind.pending, (state) => {
        state.ShowSubTaskLoading = true;
        state.ShowSubTaskError = null;
      })
      .addCase(fetchTaskFind.fulfilled, (state, action) => {
        state.ShowSubTaskLoading = false;
        state.ShowSubTaskData = action.payload;
      })
      .addCase(fetchTaskFind.rejected, (state, action) => {
        state.ShowSubTaskLoading = false;
        state.ShowSubTaskError = action.error.message;
      });
  },
});

export default userSlice.reducer;
